
document.addEventListener('DOMContentLoaded', function () {
    // Seleciona todos os elementos 'dropdown'
    var dropdowns = document.querySelectorAll('.dropdown0');

    dropdowns.forEach(function (dropdown) {
        // Adiciona evento quando o dropdown é mostrado
        dropdown.addEventListener('shown.bs.dropdown', function () {
            // Adiciona a classe 'active-dropdown' ao elemento 'dropdown'
            this.classList.add('active-dropdown');
        });

        // Adiciona evento quando o dropdown é escondido
        dropdown.addEventListener('hidden.bs.dropdown', function () {
            // Remove a classe 'active-dropdown' do elemento 'dropdown'
            this.classList.remove('active-dropdown');
        });
    });
    // Seleciona todos os elementos 'dropdown'
    var dropdowns = document.querySelectorAll('.dropdown1');

    dropdowns.forEach(function (dropdown) {
        // Adiciona evento quando o dropdown é mostrado
        dropdown.addEventListener('shown.bs.dropdown', function () {
            // Adiciona a classe 'active-dropdown' ao elemento 'dropdown'
            this.classList.add('active-dropdown2');
        });

        // Adiciona evento quando o dropdown é escondido
        dropdown.addEventListener('hidden.bs.dropdown', function () {
            // Remove a classe 'active-dropdown' do elemento 'dropdown'
            this.classList.remove('active-dropdown2');
        });
    });
    // Seleciona todos os elementos 'dropdown'
    var dropdowns = document.querySelectorAll('.dropdown2');

    dropdowns.forEach(function (dropdown) {
        // Adiciona evento quando o dropdown é mostrado
        dropdown.addEventListener('shown.bs.dropdown', function () {
            // Adiciona a classe 'active-dropdown' ao elemento 'dropdown'
            this.classList.add('active-dropdown3');
        });

        // Adiciona evento quando o dropdown é escondido
        dropdown.addEventListener('hidden.bs.dropdown', function () {
            // Remove a classe 'active-dropdown' do elemento 'dropdown'
            this.classList.remove('active-dropdown3');
        });
    });
});
